function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-size: 278.667px;\n        fill: #3c3c3d;\n        font-family: \"Creattion Demo\";\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("text", {
  id: "S",
  className: "cls-1",
  transform: "translate(160.677 349.183) scale(1.193)"
}, "S");

var _ref4 = /*#__PURE__*/React.createElement("text", {
  id: "i",
  className: "cls-1",
  transform: "translate(372.299 377.218) scale(1.193)"
}, "i");

var _ref5 = /*#__PURE__*/React.createElement("text", {
  id: "d",
  className: "cls-1",
  transform: "translate(430.808 360.43) scale(1.193)"
}, "d");

var _ref6 = /*#__PURE__*/React.createElement("text", {
  id: "i-2",
  "data-name": "i",
  className: "cls-1",
  transform: "translate(508.05 374.579) rotate(0.504) scale(1.331)"
}, "i");

var _ref7 = /*#__PURE__*/React.createElement("text", {
  id: "k",
  className: "cls-1",
  transform: "translate(581.082 347.012) scale(1.534)"
}, "k");

var _ref8 = /*#__PURE__*/React.createElement("text", {
  id: "i-3",
  "data-name": "i",
  className: "cls-1",
  transform: "translate(655.959 380.623) scale(1.193)"
}, "i");

var _ref9 = /*#__PURE__*/React.createElement("text", {
  id: "M",
  className: "cls-1",
  transform: "translate(18.732 328.706) rotate(-17.367) scale(1.376)"
}, "M");

function SvgSignature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249.988,
    height: 141.326,
    viewBox: "0 0 773 437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/signature.9f344370.svg";
export { ForwardRef as ReactComponent };